"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.graphs = void 0;

var _colors = require("./colors.theme");

var graphs = {
  barGauge: {
    radius: '16px',
    height: '1rem',
    indicatorSize: '1.5rem'
  },
  progressBar: {
    radius: '16px',
    height: '1rem',
    colorMapping: [{
      min: 0,
      max: 20,
      color: _colors.colors.warning500
    }, {
      min: 21,
      max: 40,
      color: _colors.colors.warning300
    }, {
      min: 41,
      max: 60,
      color: _colors.colors.success300
    }, {
      min: 61,
      max: 80,
      color: _colors.colors.success500
    }, {
      min: 81,
      max: 100,
      color: _colors.colors.success500
    }]
  }
};
exports.graphs = graphs;